import React, { Component } from 'react';
import { Container, Row, Col } from 'reactstrap';
import { Helmet } from 'react-helmet';
import Layout from '../../../../components/Layout/Layout';
import { connect } from 'react-redux';
import { startUpdateDashboardSettings } from '../../../../actions/webmaster';
import DashboardSettings from '../../../../components/DashboardSettings/DashboardSettings';
// import Tabloid from '../../widgets/Tabloid/Tabloid';
// import RecommendedOffersWidget3 from '../../widgets/RecommendedOffersWidget/RecommendedOffersWidget3';
// import ReferralsWidget from '../../widgets/ReferralsWidget/ReferralsWidget';
// import SidebarPromoWidget from '../../widgets/SidebarPromoWidget/SidebarPromoWidget';
import ThemeChooserWidget from '../../../../widgets/ThemeChooserWidget/ThemeChooserWidget';
import ThemeChooserSuccess from '../../../../widgets/ThemeChooserWidget/ThemeChooserSuccess';
import CoinsWidget from '../../widgets/CoinsWidget/CoinsWidget';
import FinancesWidget from '../../widgets/FinancesWidget/FinancesWidget';
import LeadsWidget from '../../widgets/LeadsWidget/LeadsWidget';
import PayoutChangesModal from '../../../../modals/PayoutChangesModal/PayoutChangesModal';

import { items } from './items';
import BannerWidget from '../../../../widgets/BannerWidget/BannerWidget';

const renderWidjgetWithExtraProps = (item) => {
  const { localStorageName, collapsing, component } = item;
  return React.cloneElement(component, { collapsing, localStorageName });
};

const renderItemsByConfig = (config = [], items = []) => {
  if (Array.isArray(config) && Array.isArray(items)) {
    return config
      .sort((a, b) => a.position > b.position)
      .reduce((ordered, cfg) => {
        const item = items.find(({ id }) => cfg.id === id);

        if (item && cfg.enabled) {
          if (ordered[cfg.position]) {
            ordered[cfg.position + 1] = renderWidjgetWithExtraProps(item);
          } else {
            ordered[cfg.position] = renderWidjgetWithExtraProps(item);
          }
        }

        return ordered;
      }, []);
  }
};

class DashboardPage extends Component {
  handleSettingsChange = (settings) => {
    this.props.startUpdateDashboardSettings(settings);
  };

  render() {
    const { config, theme } = this.props;

    return (
      <Layout>
        <Helmet title="Dashboard" />
        {/* <Row>
          <Col>
            <Tabloid />
          </Col>
        </Row> */}

        <Col lg="12">{renderItemsByConfig(config, items['additional'])}</Col>
        {/* <Col lg={{ size: 8, offset: 2 }}>
          <BannerWidget />
        </Col> */}
        <Col lg="12">{/* <BannerWidget theme={3} /> */}</Col>
        <Col xl="4" lg="12">
          <LeadsWidget />
        </Col>

        <Col xl="4" lg="12">
          <FinancesWidget />
        </Col>

        <Col xl="4" lg="12">
          <CoinsWidget />
        </Col>

        <Col xl="12">
          <Row className="dashboard-top-widgets">
            {renderItemsByConfig(config, items['widgets']).map((widget) => (
              <Col key={widget.key} xl="4" lg="12">
                {widget}
              </Col>
            ))}
            {/* <SidebarPromoWidget /> */}
          </Row>
        </Col>
        <Col xl="12">
          <Row className="dashboard-bottom-widgets">
            {renderItemsByConfig(config, items['main']).map((widget) => (
              <Col key={widget.key} xl="4" lg="12">
                {widget}
              </Col>
            ))}
          </Row>
        </Col>

        {/* <DashboardSettings config={config} items={items} onChange={this.handleSettingsChange} /> */}

        {theme === 0 && <ThemeChooserWidget />}

        {/* TODO: сделать как-нибудь по человечески */}
        {window.hasChosenTheme && <ThemeChooserSuccess theme={theme} />}
      </Layout>
    );
  }
}

const mapStateToProps = (state) => ({
  config: state.webmaster.dashboardSettings,
  theme: state.webmaster.profile.theme,
});

const mapDispatchToProps = (dispatch) => ({
  startUpdateDashboardSettings: (settings) => dispatch(startUpdateDashboardSettings(settings)),
});

export default connect(mapStateToProps, mapDispatchToProps)(DashboardPage);
